export const PROFILE_HELLO_DELAY = 1000;

export const CALLBACKS_AFTER_STATE_CHANGE = {
  start: ['hello'],
  info: ['hello'],
  share: ['hello'],
};

export const VISIBLE_ROOM_STATES = [
  'main',
  'customization',
  'wish',
  'rating',
  'gameRating',
  'friends',
  'share',
  'procedureGame',
  'oldRating',
];

export const VISIBLE_ELF_STATES = ['info', 'share', 'start'];

export const TOGGLE_VISIBLE_ELF_STATES = [{ toggleState: 'start', condition: (states) => !states.includes('share') }];
